import { Fragment, type ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { RetryNotice } from '@/ui/retry-notice'
import { LoadingNotice } from '@/ui/loading-notice'

import { useSelectedEntity } from '../../lib/entity-queries'

export function EntityListPage({
  resource,
  className,
  children,
}: {
  resource?: {
    isLoading: boolean
    error: Error | null
    refetch: () => unknown
  }
  className?: string
  children: (entity: { entityId: string; name: string }) => ReactNode
}) {
  const { entity: entityQuery } = useSelectedEntity()
  const entity = entityQuery.data ?? null
  const error = entityQuery.error ?? resource?.error

  return (
    <div className={cn('flex flex-col', className)}>
      {entityQuery.isLoading ? (
        <LoadingNotice message="Loading entity…" />
      ) : resource?.isLoading ? (
        <LoadingNotice message="Loading…" />
      ) : entity && !error ? (
        <Fragment key={entity.entityId}>{children(entity)}</Fragment>
      ) : (
        <RetryNotice
          className="p-6"
          message={error ? error.message : 'Entity unavailable.'}
          onRetry={() =>
            void (entityQuery.error || !resource
              ? entityQuery.refetch()
              : resource.refetch())
          }
        />
      )}
    </div>
  )
}
